import ComponentModule from "@eisinc/Overrides/Components/AddToListModal";

export * from "@eisinc/Overrides/Components/AddToListModal";

export default ComponentModule;
